// extracted by mini-css-extract-plugin
export var container = "zH69THwM";
export var subtitle = "aoKXsMgf";